/**
 * Interfaces related to Itinerary CRUD, LIST
 */

export interface IWayPoint {
    id: number,
    sequenceId: number,
    comment: string,
    selectedCoordinate: number,
    elevation: string,
    itineraryName: string,
    latitude: string,
    latitudeDD: string,
    latitudeDM: string,
    latitudeDMS: string,
    longitude: string,
    longitudeDD: string,
    longitudeDM: string,
    longitudeDMS: string
}
export enum SelectedCoordinate {
    DD,
    DM,
    DMS
}
